import React from "react";
import TransportForm from "../../components/forms/transportForm/index";
import { useState, useEffect } from "react";
import url from "../../config/axios";
import { useParams } from "react-router-dom";

const TransportProfileUpdate = () => {
  const { id } = useParams();
  const [updatedData, setUpdatedData] = useState();
  useEffect(() => {
    url.get(`shop/id?id=${id}`).then(async (res) => {
      setUpdatedData(res?.data?.data?.Shop);
      console.log("updated data", res);
    });
  }, []);
  const updatehandel = () => {
    alert("ddd");
  };

  return (
    <>
      <TransportForm
        inputtitle="Profile Name"
        butn="Update"
        createShop={updatedData}
        id={id}
        updatehandel={updatehandel}
        link="/transport-profile-update/"
      />
    </>
  );
};

export default TransportProfileUpdate;
